import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import { CONFIG } from '../../../../config';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import LoaderModal from '../../../modal/LoaderModal';
import accountManagement from '../../../../apis/accountManagement';
import KelasSearch from '../../../../entity/KelasSearch';

import TableKelas from './TableKelas';
import KelasPararel from '../../../../entity/KelasPararel';
import ModalAdd from './ModalAdd';
import ModalDelete from './ModalDelete';

class Kelas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            isResponse: false,
            responseType: null,
            responseMesagge: null,
            isShowAdd: false,
            isShowEdit: false,
            isShowDelete: false,
            sekolah: {},
            KelasEnt: [],
            kelasDropdown: [],
            guruDropdown: [],
            kelas: [],
            idKelasParalel: 0,
            idSekolah: '',
            idKelas: '',
            namaKelasParalel: '',
            idGuru: ''
        }
        
        this.fetchKelas = this.fetchKelas.bind(this);
    }

    async componentDidMount() {
        document.title = "Kelas";
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
            this.fetchKelas();
        }

        this.setState({
            isFetching: false
        });
    }

    handleCloseAlert() {
        this.setState({
            isResponse: false,
            responseType: null,
            responseMesagge: null,
        })
    }

    clearStateParent() {
        this.setState({
            idKelasParalel: 0,
            idSekolah: '',
            idKelas: '',
            namaKelasParalel: '',
            idGuru: ''
        })
    }
    
    fetchKelas = async () => {
        this.setState({
            isFetching: false
        });
        // Fetch Sekolah Dulu
        const that = this;
        await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah)
        .then(function(response) {
            if (response.request.readyState === 4 && response.status === 200) {
                return response.data;
            }
        })
        .then(function(jsonData) {
            if (jsonData) {
                if (jsonData.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    return jsonData.data;
                }
            }
        })
        .then(function(jsonStr) {
            that.setState({
                sekolah: jsonStr
            });
        })
        .catch(function(error) {
            console.log('Kelas.js Error Fetch Sekolah = ', error);
        });

        // Fetch Kelas setelah dapat data sekolah
        const responseFetchKelas = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, "kodeJenjangSekolah": this.state.sekolah.kodeJenjangSekolah})
        .catch(function(error) {
            console.log('Kelas.js Error Fetch Kelas = ', error);
        });

        // Set State Kelas
        if(responseFetchKelas.request.readyState === 4 && responseFetchKelas.status === 200) {
            if(responseFetchKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelasDropdown: responseFetchKelas.data.data
                })
            }
        }

        // Fetch Guru
        const responseFetchGuru = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_FETCH_GURU, {'idSekolah': this.state.sekolah.idSekolah})
        .catch(function(error) {
            console.log('Kelas.js Error Guru Kelas = ', error);
        });

        // Set State Kelas
        if(responseFetchGuru.request.readyState === 4 && responseFetchGuru.request.status === 200) {
            if(responseFetchGuru.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    guruDropdown: responseFetchGuru.data.data
                })
            }
        }

        // Fetch List Kelas
        const resFetchKelas = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_LIST_KELAS_PARAREL + this.state.sekolah.idSekolah)
        .catch(function(error) {
            console.log('Kelas.js Error Fetch List ', error);
        });

        if(resFetchKelas.status === 200) {
            if(resFetchKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    KelasEnt: resFetchKelas.data.data
                });
            }
        }

        this.setState({
            isFetching: false
        });
    }
    
    submitFormAdd = async (e) => {
        e.preventDefault();
        this.setState({
            isFetching: true,
            isShowAdd: false
        });
        
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_CREATE_KELAS_PARAREL , {...KelasPararel,
            "idSekolah": this.props.account.idSekolah,
            "idKelas": this.state.idKelas,
            "namaKelasParalel": this.state.namaKelasParalel,
            "idGuru": this.state.idGuru
        })
        .catch(function(error) {
            console.groupCollapsed('Kelas.js Handle Submit Add Error');
            console.log(error);
            console.groupEnd();
        });

        if (response) {
            if(response.data.data.result) {
                this.setState({
                    isResponse: true,
                    responseType: 'Success',
                    responseMesagge: response.data.data.message
                }, () => {
                    this.fetchKelas()
                    this.clearStateParent()
                });
            }
            else {
                this.setState({
                    isResponse: true,
                    responseType: 'danger',
                    responseMesagge: response.data.data.message
                }, () => {
                    this.fetchKelas()
                    this.clearStateParent()
                });
            }
        }
        else {
            this.setState({
                isResponse: true,
                responseType: 'danger',
                responseMesagge: 'Terjadi kesalahan.'
            }, () => {
                this.fetchKelas()
                this.clearStateParent()
            });
        }
        
        this.setState({
            isFetching: false
        });
    }

    submitFormEdit = async (e) => {
        e.preventDefault();
        this.setState({
            isFetching: true,
            isShowEdit: false
        });
        
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_UPDATE_KELAS_PARAREL , {...KelasPararel,
            "idSekolah": this.props.account.idSekolah,
            "idKelasParalel": this.state.idKelasParalel,
            "idKelas": this.state.idKelas,
            "namaKelasParalel": this.state.namaKelasParalel,
            "idGuru": this.state.idGuru
        })
        .catch(function(error) {
            console.groupCollapsed('Kelas.js Handle Submit Error');
            console.log(error);
            console.groupEnd();
        });

        if (response) {
            if(response.data.data.result) {
                this.setState({
                    isResponse: true,
                    responseType: 'Success',
                    responseMesagge: response.data.data.message
                }, () => {
                    this.fetchKelas()
                    this.clearStateParent()
                });
            }
            else {
                this.setState({
                    isResponse: true,
                    responseType: 'danger',
                    responseMesagge: response.data.data.message
                }, () => {
                    this.fetchKelas()
                    this.clearStateParent()
                });
            }
        }
        else {
            this.setState({
                isResponse: true,
                responseType: 'danger',
                responseMesagge: 'Terjadi kesalahan.'
            }, () => {
                this.fetchKelas()
                this.clearStateParent()
            });
        }

        this.setState({
            isFetching: false
        });
    }

    submitFormDelete = async (e) => {
        e.preventDefault();
        this.setState({
            isFetching: true,
            isShowDelete: false
        });
        
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_DELETE_KELAS_PARAREL , {...KelasPararel,
            "idSekolah": this.state.idSekolah,
            "idKelasParalel": this.state.idKelasParalel
        })
        .catch(function(error) {
            console.groupCollapsed('Kelas.js Handle Submit Error');
            console.log(error);
            console.groupEnd();
        });
        
        if(response) {
            if(response.data.data.result) {
                this.setState({
                    isResponse: true,
                    responseType: 'Success',
                    responseMesagge: response.data.data.message
                }, () => {
                    this.fetchKelas()
                    this.clearStateParent()
                });
            }
            else {
                this.setState({
                    isResponse: true,
                    responseType: 'danger',
                    responseMesagge: response.data.data.message
                }, () => this.clearStateParent());
            }
        }
        else {
            this.setState({
                isResponse: true,
                responseType: 'danger',
                responseMesagge: 'Gagal hapus data, terjadi kesalahan'
            }, () => this.clearStateParent())
        }

        this.setState({
            isFetching: false
        });
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({
            isResponse: true,
            responseType: 'danger',
            responseMesagge: 'Terjadi kesalahan'
        }, () => this.clearStateParent())
        console.log('Catch Error', error);
        console.log('Catch Info', info);
    }

    onChange(field, value) {
        console.log('= Kelas.js onChange =', field, value);
        this.setState({
            [field]: value
        });
    }

    render() {
        const KelasEnt = this.state.KelasEnt;
        const idSekolah = this.props.account.idSekolah;
        const optionKelasDropdown = this.state.kelasDropdown;
        const optionGuruDropdown = this.state.guruDropdown;

        if(!idSekolah) {
            return null;
        }

        if(!KelasEnt && !optionKelasDropdown && !optionGuruDropdown) {
            return null;
        }

        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />
                    <div className="row">
                        <div className="col-sm-12">
                            {
                                this.state.isResponse &&
                                <div className={"alert alert-" + (this.state.responseType === 'Success' ? 'success' : 'danger') + " alert-dismissible fade show"} role="alert">
                                    <strong>{this.state.responseType === 'Success' ? 'Sukses!' : 'Upss...!'}</strong> {this.state.responseMesagge}
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={() => this.handleCloseAlert()}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            }
                            <div className="pull-left">
                                <ModalAdd
                                    statusModal={this.state.isShowAdd}
                                    clearAlert={this.handleCloseAlert.bind(this)}
                                    kelasDropdown={optionKelasDropdown}
                                    guruDropdown={optionGuruDropdown}
                                    eventSubmit={this.submitFormAdd}
                                    onChange={this.onChange.bind(this)}
                                />
                            </div>
                            
                            <div className="clearfix">&nbsp;</div>
                            <br></br>

                            <div>
                                <TableKelas
                                    statusModalEdit={this.state.isShowEdit}
                                    clearAlert={this.handleCloseAlert.bind(this)}
                                    kelasDropdown={optionKelasDropdown}
                                    guruDropdown={optionGuruDropdown}
                                    dataKelas={KelasEnt}
                                    onChange={this.onChange.bind(this)}
                                    eventSubmit={this.submitFormEdit}
                                />
                                
                                <ModalDelete
                                    statusModal={this.state.isShowDelete}
                                    clearAlert={this.handleCloseAlert.bind(this)}
                                    onChange={this.onChange.bind(this)}
                                    idSekolah={this.state.idSekolah}
                                    idKelasParalel={this.state.idKelasParalel}
                                    eventSubmit={this.submitFormDelete}
                                />
                            </div>
                        </div>
                    </div>  
                </div>
                
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Kelas)
